import { render } from "./CustomTextButton.vue?vue&type=template&id=1058abd6&scoped=true"
import script from "./CustomTextButton.vue?vue&type=script&lang=js"
export * from "./CustomTextButton.vue?vue&type=script&lang=js"

import "./CustomTextButton.vue?vue&type=style&index=0&id=1058abd6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1058abd6"]])

export default __exports__